export const GET_EXPERIENCE_COMPANY_ENDPOINT = (searchQuery: string) =>
  `/experience/company${searchQuery ? `?q=${searchQuery}` : ''}`;
